"use client";

export const MEDIA_STOP_PLAYBACK_EVENT = "imags:media-stop-playback";

export type MediaStopPlaybackEventDetail = {
  promises?: Promise<unknown>[];
  reason?: string;
  resetPosition?: boolean;
};

export async function requestMediaPlaybackStop(
  reason: string,
  options: { resetPosition?: boolean } = {}
) {
  if (typeof window === "undefined") return;

  const promises: Promise<unknown>[] = [];
  window.dispatchEvent(
    new CustomEvent<MediaStopPlaybackEventDetail>(MEDIA_STOP_PLAYBACK_EVENT, {
      detail: {
        promises,
        reason,
        resetPosition: options.resetPosition ?? true,
      },
    })
  );

  if (promises.length > 0) {
    await Promise.allSettled(promises);
  }
}
